import { useContext } from 'react'
import Parse from 'html-react-parser'
import { ThemeContext } from '../../../contexts/theme'

import * as S from './styles'

import Logo from '../../login/Logo'
import Social from '../../login/Social'

function CardCompany(props) {
  const themeContext = useContext(ThemeContext)
  return (
    <S.MainContainer>
      <S.Card className={props.active === 'cardCompany' ? 'toFront' : ''} onClick={props.onClick}>
        <S.LogoContainer>
          <Logo />
        </S.LogoContainer>

        <S.Text>{Parse(themeContext.login_phrase)}</S.Text>

        <S.SocialContainer>
          <Social />
        </S.SocialContainer>
      </S.Card>
    </S.MainContainer>
  )
}

export default CardCompany
